import Vue from 'vue'

interface WW {
  appVariant: any
  $state: any
  uid: any
  vueStartingState: any
  realtime: any
  navigateDesktopApp?: (url: string, target?: string) => void
  /**
   * Old native bridge. Currently being used by
   * the mobile app.
   */
  nativeBridge: any
}

/**
 * The ResizeObserver interface is used to observe changes to Element's content
 * rect.
 *
 * It is modeled after MutationObserver and IntersectionObserver.
 */
export interface ResizeObserver {
  new (callback: ResizeObserverCallback);

  /**
   * Adds target to the list of observed elements.
   */
  observe: (target: Element) => void;

  /**
   * Removes target from the list of observed elements.
   */
  unobserve: (target: Element) => void;

  /**
   * Clears both the observationTargets and activeTargets lists.
   */
  disconnect: () => void;
}

/**
 * This callback delivers ResizeObserver's notifications. It is invoked by a
 * broadcast active observations algorithm.
 */
export interface ResizeObserverCallback {
  (entries: ResizeObserverEntry[], observer: ResizeObserver): void;
}

export interface ResizeObserverEntry {
  /**
   * @param target The Element whose size has changed.
   */
  new (target: Element);

  /**
   * The Element whose size has changed.
   */
  readonly target: Element;

  /**
   * Element's content rect when ResizeObserverCallback is invoked.
   */
  readonly contentRect: DOMRectReadOnly;
}

interface DOMRectReadOnly {
  fromRect(other: DOMRectInit | undefined): DOMRectReadOnly;

  readonly x: number;
  readonly y: number;
  readonly width: number;
  readonly height: number;
  readonly top: number;
  readonly right: number;
  readonly bottom: number;
  readonly left: number;

  toJSON: () => any;
}

interface BrowserWindow extends Window {
  safari?: any
  PushManager?: any
  ww: WW
  /** New native bridge, allows access to the Vuex store. */
  $nativeBridge: any
  app?: Vue
  google: any // from asynchronous Google Javascript API, currently only Maps API (in google_map.ts)
  Brightback: any // from Brightback offboarding flow script. https://brightback.com/
  ResizeObserver: ResizeObserver
}

const browserWindow = window as BrowserWindow
export const ww = browserWindow.ww
export default browserWindow
